export const BUY_FORM = 'buyForm';
export const BUY_FORM_TERMS_FIELD = 'terms';

export const BUY_INITIAL_STATE = {
    [BUY_FORM_TERMS_FIELD]: {
        value: false,
        isValid: true,
        errorMessage: null,
    },
};
